(ns ycweb.app.website.cart.minicart
  (:require
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.app.website.cart.addtocart]
   [ycweb.app.website.cart.model :as model]
   [ycweb.app.website.cart.parts.common :as cart.common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.grid :as grid]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.core :as u]))

;; Use the button-icon component from common components instead of defining our own

(rum/defc cart-preview-item < rum/reactive
  [{:keys [variation_uuid price item-name qty
           timeleft expires_at subscription special cartitem_uuids cover_voucher]
    :as item}
   variation cover app-atom]
  (let [product-info (:product variation)
        variation-title (:title variation)
        item-name
        (cond
          (and cover_voucher (not (:forregistry_uuid item)))
          (str "Yuppiechef " (:method cover) " Gift Voucher ")

          :else
          (or item-name variation-title "Unknown Item"))

        product-image
        (cond
          cover_voucher
          (or
            (get-in cover [:image :public_id])
            (:public_id item)
            (get-in variation [:image :public_id]))

          :else
          (or (:public_id item)
            (get-in special [:docs :cart :mini :public_id])
            (get-in variation [:image :public_id])
            (:image product-info)))

        price-formatted (str "R" (u/currency-format price 0 ","))]
    [:li {:class (u/bem :cart-preview-list__item)}
     [:a {:class (u/bem :cart-preview-list__content)
          :href (:page_url variation)}
      [:figure {:class (u/bem :cart-preview-list__image)}
       [:img {:src (u/cloudinary product-image {:c "lpad" :e "sharpen:40" :f "auto" :h 43 :q "auto" :w 43})
              :alt item-name}]]
      [:div {:class (u/bem :cart-preview-list__text)}
       [:span {:class (u/bem :cart-preview-list__product)} item-name]
       [:span {:class (u/bem :u-hidden-from-view)} ":"]
       [:span {:class (u/bem :cart-preview-list__price)} (str qty " x " price-formatted)]

       ;; Cart item expiry countdown (carttimeout)
       (when expires_at
         (cart.common/expiry-countdown expires_at {:mini? true}))

       ;; Time-limited offer warning (for specials)
       (when timeleft
         (feedback/feedback :warning
           nil
           nil
           nil
           :mini
           nil
           [:span
            [:b "Please note:"] (str " You have " timeleft " minutes to check out in order to secure this special offer.")]))

       ;; Subscription message
       (when-let [subscription subscription]
         (feedback/feedback :info
           nil
           nil
           nil
           :mini
           nil
           [:span
            (:message subscription)]))]]

     [:span {:class (u/bem :u-hidden-from-view)} " — "]
     [:a {:class (u/bem :cart-preview-list__remove-button :icon-link :icon-block-link [:size-default] :remove)
          :href "#"
          :on-click
          (fn [e]
            (.preventDefault e)
            (grid/confirm-modal app-atom
              {:title "Remove Item"
               :text "Are you sure you want to remove this item from your Cart?"
               :negative true
               :confirm-text "Remove"
               :confirm-key :cart/remove-item
               :confirm-data {:cartitem_uuids cartitem_uuids}}))}
      [:i {:class (u/bem :icon [:delete :is-dark :default :inline])}
       [:span {:class (u/bem :u-hidden-from-view)} "Remove Item"]]]]))

(rum/defc delivery-charge-item < rum/reactive
  [delivery-details country]
  [:li {:class (u/bem :cart-preview-list__item)}
   [:div {:class (u/bem :cart-preview-list__content)}
    [:figure {:class (u/bem :cart-preview-list__image)}
     [:img {:class (u/bem :icon [:block])
            :src (u/build-url "res.cloudinary.com"
                   (str "/yuppiechef/image/upload/ui-resources/shared/flags/"
                     (str/lower-case (or (:code country) "za"))
                     ".svg"))}]]
    [:div {:class (u/bem :cart-preview-list__text)}
     [:span {:class (u/bem :cart-preview-list__product)}
      (if (= (:deliverymethod delivery-details) "Collect")
        "Collection from store"
        "Delivery to your door")]
     [:span {:class (u/bem :u-hidden-from-view)} ":"]
     [:span {:class (u/bem :cart-preview-list__price)}
      (str "R" (u/currency-format (:fee delivery-details) 0 ","))]]]])

(rum/defc cart-footer < rum/reactive
  [rolled-up-items {:keys [delivery] :as totals}]
  [:div {:class (u/bem :u-text-center)}

   (when (> (count rolled-up-items) 4)
     [:p {:class (u/bem :cart-preview__more-items)}
      [:a {:class (u/bem :text-link [:muted])
           :href "/order.htm?action=ShowCart"}
       "View all " (count rolled-up-items) " items"]])
   [:p {:class (u/bem :cart-preview__total)} (str "Order total: R" (u/currency-format (:total totals) 0 ","))]
   (cond
     ;; Free delivery already applies
     (and
       (get-in totals [:delivery :applies])
       (> (:item_total totals) (:threshold delivery)))
     [:p {:class (u/bem :cart-preview__delivery-note)}
      "Your order has " [:b {:class (u/bem :text-status [:important] :u-text-uppercase)} "free delivery"]
      [:span {:class (u/bem :cart-preview__delivery-footnote)}
       " or collection from Yuppiechef stores and selected PostNet branches."]]

     ;; Delivery threshold message
     (get-in totals [:delivery :applies])
     [:div
      [:p {:class (u/bem :cart-preview__delivery-note)}
       [:span {:class (u/bem :text-status [:important])}
        "Spend R"
        (u/currency-format (- (:threshold delivery) (:item_total totals)) 0 ",")
        " more to get "
        [:span
         [:b {:class (u/bem :u-text-uppercase)} "free delivery"]
         " to your door"]]]
      [:p {:class (u/bem :cart-preview__delivery-footnote :u-max-width-320 :u-block-center)}
       [:b "Or choose to collect free of charge"]
       " from Yuppiechef stores or for R" (u/currency-format (:partner_charge delivery) 0 ",") " from selected PostNet branches."]])

   [:div {:class (u/bem :u-block-center :u-max-width-320)}
    (buttons/button "Check Out"
      #?(:cljs
         #(js/window.location.assign "/order.htm?action=ShowCart")
         :clj #())
      {:raised true
       :full true})]

   [:a {:class (u/bem :u-block-link :u-text-center)
        :href "/order.htm?action=ShowCart"}
    [:small {:class (u/bem :cart-preview__alt-action)} "Or view your Cart"]]])

(rum/defc cart-modal-body < rum/reactive [app-atom config-atom _]
  (let [{:keys [cart items variations covers totals hasphysicalitems country]}
        (cmn/curact app-atom [:cart-summary])

        delivery_details (:delivery_details totals)

         ;; Roll up items by variation_uuid and price
        rolled-up-items
        (when (and items variations)
          (->>
            (model/roll-up-cart-items items variations)
            (filter #(pos? (:price %)))))]

    (if (or (nil? cart) (empty? items))
      [:div {:class (u/bem :minicart-empty)}
       [:p "Your cart is empty"]
       (buttons/button "Continue Shopping"
         #?(:cljs
            #(js/window.location.assign "/index.htm")
            :clj #())
         {:raised true})]

      ;; Font weight in the header is bold. need to clear.
      [:div {:style {:font-weight "normal"}}
       [:h2 {:class (u/bem :yc-heading [:small])} "Items in Your Cart"]

       [:ul {:class (u/bem :cart-preview-list)}
        (for [item (take 4 rolled-up-items)
              :let [variation (get variations (:variation_uuid item))
                    cover (get covers (:cover_refid (:cover_voucher item)))]]

          (rum/with-key
            (cart-preview-item item variation cover app-atom)
            (:cartitem_uuid item)))

        ;; Delivery charge item
        (when (and (:applies delivery_details)
                (pos? (:fee delivery_details)))
          (delivery-charge-item delivery_details country))]

       ;; Cart footer with totals
       (cart-footer rolled-up-items totals)])))

(rum/defc minicart-button < rum/reactive cmn/cursors [app-atom]
  (let [{:keys [totals]} (cmn/curact app-atom [:cart-summary])
        total-qty (:item_count totals)]
    (cond
      (and total-qty (> total-qty 0))
      [:a {:class (u/bem :user-cart :user-nav__link :cart-link)
           :href "#"
           :on-click
           (fn [e]
             (.preventDefault e)
             (grid/open-modal app-atom :minicart/cart-popup {}))}

       (buttons/button-icon
         {:icon :cart
          :icon-color :light
          :icon-class :user-nav__link-icon})
       [:span {:class (u/bem :user-cart__count [:has-items])}
        [:span {:class (u/bem :u-hidden-from-view)} "View items in your Cart: "]
        [:span {:class (u/bem :user-cart__count-text :count)} total-qty]]]

      ;; Cart is known to be empty
      (= total-qty 0)
      [:span {:class (u/bem :user-cart :user-nav__link :cart-link)}
       (buttons/button-icon
         {:icon :cart
          :icon-color :light
          :icon-class :user-nav__link-icon})
       [:span {:class (u/bem :user-cart__count [:no-items])}
        [:span {:class (u/bem :u-hidden-from-view)} "Items in your Cart: "]
        [:span {:class (u/bem :user-cart__count-text :count)} "0"]]]

      ;; Reserve the slot so the header doesn't shift when the count arrives
      :else
      [:span {:class (u/bem :user-cart :user-nav__link :cart-link)}
       (buttons/button-icon
         {:icon :cart
          :icon-color :light
          :icon-class :user-nav__link-icon})
       [:span {:class (u/bem :user-cart__count [:no-items])}
        [:span {:class (u/bem :u-hidden-from-view)} "Items in your Cart: "]
        [:span {:class (u/bem :user-cart__count-text :count)} "0"]]])))

(rum/defcs minicart < rum/reactive
  [s app-atom & [root?]]
  [:li {:class (u/bem :user-nav__item :user-nav__item--cart)}
   [:div {:class (u/bem :minicart-component)}
      ;; Cart icon in header
    (minicart-button app-atom)

      ;; Modal components - these will be rendered at the app root level if needed
    (when root?
      [:<>
       (toaster/progress-toaster-overlay app-atom)
       (toaster/progress-toaster app-atom)
       (grid/modal app-atom false)
       (grid/modal-background app-atom)])]])

(defmethod grid/action :minicart/close-popup [app-atom _ _]
  (grid/close-modal app-atom))

(defmethod grid/modal-config :minicart/cart-popup [_ _ _]
  {:body cart-modal-body
   :modal-type :variable
   :cancel-key :minicart/close-popup})
